// A completed participant section is not a GM review or visa approval.
export function preparationStatus(tasks, {started, completed, reviewed}) {
  if (tasks.length && tasks.every(task => completed.has(task) && reviewed.has(task))) return 'provided';
  // Navigation and prefilled data are not participant work. Partial completion
  // or review still counts, even when later edits invalidate completion.
  return tasks.some(task => started.has(task) || completed.has(task) || reviewed.has(task)) ? 'in_progress' : 'not_started';
}

export function preparationTaskKeys({personal, travel, production, immigration}) {
  return [...new Set(['passport', 'profile_center', ...personal,
    ...(immigration.includes('accompanying_family') ? ['contact_details'] : []),
    ...travel, ...production, ...immigration.filter(key => key !== 'accompanying_family')])];
}

// Preserve the existing family collection rule, including unsaved member drafts.
export function familyInformationReady(answer, memberCount, hasDraft) {
  return answer === 'no' || (answer === 'yes' && memberCount > 0 && !hasDraft);
}
